import React, { useState } from "react";
import { LockIcon, ShieldIcon, EyeIcon, EyeOffIcon } from "./SettingsIcons";

const SettingsAccountTab = ({ twoFactor, setTwoFactor }) => {
  const [currentPwd, setCurrentPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <>
      {/* Change Password Card */}
      <div className="v2-settings-pg-card">
        <div className="v2-settings-pg-card__header">
          <div className="v2-settings-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
            <LockIcon size={20} color="#eb1414" />
          </div>
          <div>
            <h3 className="v2-settings-pg-card__title">Change Password</h3>
            <p className="v2-settings-pg-card__subtitle">
              Update your password to keep your account secure
            </p>
          </div>
        </div>

        <div className="v2-settings-pg-card__body">
          {/* Current Password */}
          <div className="v2-settings-pg-field">
            <label className="v2-settings-pg-field__label">Current Password</label>
            <div className="v2-settings-pg-input-wrap">
              <input
                type={showCurrent ? "text" : "password"}
                className="v2-settings-pg-input"
                placeholder="Enter current password"
                value={currentPwd}
                onChange={(e) => setCurrentPwd(e.target.value)}
              />
              <button
                type="button"
                className="v2-settings-pg-input-eye"
                onClick={() => setShowCurrent(!showCurrent)}
              >
                {showCurrent ? (
                  <EyeOffIcon size={18} color="#9ca3af" />
                ) : (
                  <EyeIcon size={18} color="#9ca3af" />
                )}
              </button>
            </div>
          </div>

          {/* New Password */}
          <div className="v2-settings-pg-field">
            <label className="v2-settings-pg-field__label">New Password</label>
            <div className="v2-settings-pg-input-wrap">
              <input
                type={showNew ? "text" : "password"}
                className="v2-settings-pg-input"
                placeholder="Enter new password"
                value={newPwd}
                onChange={(e) => setNewPwd(e.target.value)}
              />
              <button
                type="button"
                className="v2-settings-pg-input-eye"
                onClick={() => setShowNew(!showNew)}
              >
                {showNew ? (
                  <EyeOffIcon size={18} color="#9ca3af" />
                ) : (
                  <EyeIcon size={18} color="#9ca3af" />
                )}
              </button>
            </div>
          </div>

          {/* Confirm New Password */}
          <div className="v2-settings-pg-field">
            <label className="v2-settings-pg-field__label">Confirm New Password</label>
            <div className="v2-settings-pg-input-wrap">
              <input
                type={showConfirm ? "text" : "password"}
                className="v2-settings-pg-input"
                placeholder="Confirm new password"
                value={confirmPwd}
                onChange={(e) => setConfirmPwd(e.target.value)}
              />
              <button
                type="button"
                className="v2-settings-pg-input-eye"
                onClick={() => setShowConfirm(!showConfirm)}
              >
                {showConfirm ? (
                  <EyeOffIcon size={18} color="#9ca3af" />
                ) : (
                  <EyeIcon size={18} color="#9ca3af" />
                )}
              </button>
            </div>
          </div>

          <button className="v2-settings-pg-btn-primary">
            <span>Update Password</span>
          </button>
        </div>
      </div>

      {/* Two-Factor Authentication Card */}
      <div className="v2-settings-pg-card" style={{ marginTop: "var(--v2-spacing-6)" }}>
        <div className="v2-settings-pg-card__header">
          <div className="v2-settings-pg-card__icon-wrap" style={{ background: "#dcfce7" }}>
            <ShieldIcon size={20} color="#22c55e" />
          </div>
          <div>
            <h3 className="v2-settings-pg-card__title">Two-Factor Authentication</h3>
            <p className="v2-settings-pg-card__subtitle">
              Add an extra layer of security to your account
            </p>
          </div>
        </div>

        <div className="v2-settings-pg-card__body">
          <div className="v2-settings-pg-toggle-row">
            <div className="v2-settings-pg-toggle-row__text">
              <span className="v2-settings-pg-toggle-row__label">Enable 2FA</span>
              <span className="v2-settings-pg-toggle-row__desc">
                Require a verification code in addition to your password when signing in
              </span>
            </div>
            <button
              className={`v2-settings-pg-toggle${twoFactor ? " v2-settings-pg-toggle--on" : ""}`}
              onClick={() => setTwoFactor(!twoFactor)}
            >
              <span className="v2-settings-pg-toggle__knob" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsAccountTab;
